export function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/locale/constructor.js
// module id = 399
// module chunks = 113